import Tabs from "@/lib/components/Tabs";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import ElementEditor from "./ElementEditor/ElementEditor";
import SceneTab from "./SceneTab";
import ElementsListTab from "./ElementsList/ElementsListTab";
import MediaSelectorDialog from "../MediaSelectorDialog";

export const overlayTabs = [
  { label: "Elements", value: "elements" as const },
  { label: "Start scene", value: "startScene" as const },
  { label: "End scene", value: "endScene" as const },
];

export default function OverlaysTab() {
  const overlaysTabState = useEditorStore((state) => state.overlaysTabState);
  const updateOverlaysTabState = useEditorStore(
    (state) => state.service.updateOverlaysTabState,
  );
  const seekToScene = useEditorStore((state) => state.service.seekToScene);

  return (
    <>
      <MediaSelectorDialog
        sceneType={
          overlaysTabState.currentTab === "elements"
            ? "mainScene"
            : overlaysTabState.currentTab
        }
      />
      {overlaysTabState.currentElement !== null ? (
        <ElementEditor
          key={overlaysTabState.currentElement.externalId}
          elementExternalId={overlaysTabState.currentElement.externalId}
          sceneType={overlaysTabState.currentElement.sceneType}
        />
      ) : (
        <div className="h-full w-full">
          <Tabs
            currentTab={overlaysTabState.currentTab}
            animateContent={false}
            onTabClicked={(tab) => {
              updateOverlaysTabState((state) => {
                state.currentTab = tab;
              });
              seekToScene(tab === "elements" ? "mainScene" : tab);
            }}
            options={overlayTabs}
            renderCurrentTab={(tab) => {
              if (tab === "elements") {
                return <ElementsListTab />;
              }

              if (tab === "startScene") {
                return <SceneTab sceneType="startScene" />;
              }

              if (tab === "endScene") {
                return <SceneTab sceneType="endScene" />;
              }

              return null;
            }}
          />
        </div>
      )}
    </>
  );
}
